import { IMAGES } from "../lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "../lzapp_web_common_code/constant/event";

import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SEC,
  PRACTICE_TEST as PRACTICE_TEST_SEC,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SEC,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SEC,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SEC,
} from "./securityplus";
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SEC_701,
  PRACTICE_TEST as PRACTICE_TEST_SEC_701,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SEC_701,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SEC_701,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SEC_701,
} from "./securityplus701";

import LOGO_SEC from "./securityplus/logo_app_title.png";
import LOGO_SEC_701 from "./securityplus701/logo_app_title.png";

export const APP_BUNDLES = [
  {
    title: "Security+ (SY0-701)",
    key: "SECURITYPLUS701",
    bundle_firebase_collection_name: "SECURITYPLUS701",
    bundle_id: 1,
    THEME_DARK: "#0973ba",
    THEME_LIGHT: "#f79764",
    THEME_BORDER: "#0868a7",
    PREMIUM_BACKGROUND: "#e6f1f8",
    THEME_DARK_MODE: "#1E1F25",
    THEME_LIGHT_DARK_MODE: "#f79764",
    THEME_BORDER_DARK_MODE: "#18191e",
    PREMIUM_BACKGROUND_DARK_MODE: "#1E1F25"
  },
  {
    title: "Security+ (SY0-601)",
    key: "SECURITYPLUS",
    bundle_firebase_collection_name: "SECURITYPLUS",
    bundle_id: 1,
    THEME_DARK: "#0973ba",
    THEME_LIGHT: "#f79764",
    THEME_BORDER: "#0868a7",
    PREMIUM_BACKGROUND: "#e6f1f8",
    THEME_DARK_MODE: "#1E1F25",
    THEME_LIGHT_DARK_MODE: "#f79764",
    THEME_BORDER_DARK_MODE: "#18191e",
    PREMIUM_BACKGROUND_DARK_MODE: "#1E1F25"
  },
];

export const APP_DATA = {
  SUBSCRIPTION_PLANS: [1, 3, 6, 12],
  DISPLAY_APP_NAME: "CompTIA Security+",
  APP_ID: "1552045561",
};

export const GET_APP_NAME = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "SECURITYPLUS701") {
      return "SECURITYPLUS701";
    } else if (SELECTED_BUNDLE == "SECURITYPLUS") {
      return "SECURITYPLUS";
    }
  } else {
    return "SECURITYPLUS701";
  }
};

export const GET_APP_NAME_FOR_COLLECTION = async () => {
  const result = await localStorage.getItem(
    USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS
  );
  if (result) {
    if (result == "SECURITYPLUS701") {
      return "SECURITYPLUS701";
    } else if (result == "SECURITYPLUS") {
      return "SECURITYPLUS";
    }
  } else {
    return "SECURITYPLUS";
  }
};

export const APP_NAME = "SECURITYPLUS";

export const BUNDLE_APP_NAME = "SECURITYPLUS_BUNDLE";

export const IS_BUNDLE_APP = true;

export const GET_APP_NAME_FOR_LOGO = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "SECURITYPLUS701") {
      return "CompTIA <strong>Security+ SY0-701 </strong> Exam Prep";
    } else if (SELECTED_BUNDLE == "SECURITYPLUS") {
      return "CompTIA <strong>Security+ SY0-601 </strong> Exam Prep";
    } 
  } else {
    return "CompTIA <strong>Security+ SY0-701 </strong> Exam Prep";
  }
};

export const GET_QUESTION_VERSION_OF_JSON = async () => {
  const result = await localStorage.getItem(
    USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS
  );
  if (result) {
    if (result == "SECURITYPLUS701") {
      return QUESTION_VERSION_OF_JSON_SEC_701;
    } else if (result == "SECURITYPLUS") {
      return QUESTION_VERSION_OF_JSON_SEC;
    }
  } else {
    return QUESTION_VERSION_OF_JSON_SEC;
  }
};

export let THEME_DARK = "#8C1C21";
export let THEME_LIGHT = "#E53D43";
export let THEME_BORDER = "#992B30";
export let PREMIUM_BACKGROUND = "#FFEAE0";
export let THEME_DARK_MODE = "#1E1F25";
export let THEME_LIGHT_DARK_MODE = "#e1e1e1";
export let THEME_BORDER_DARK_MODE = "#992B30";
export let PREMIUM_BACKGROUND_DARK_MODE = "#1E1F25";

/*** STATIC STRINGS ***/
const app_url = "https://www.learnzapp.com/apps/securityplus";

export const GET_PRACTICE_TEST = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "SECURITYPLUS701") {
      return PRACTICE_TEST_SEC_701;
    } else if (SELECTED_BUNDLE == "SECURITYPLUS") {
      return PRACTICE_TEST_SEC;
    }
  } else {
    return PRACTICE_TEST_SEC;
  }
};

export const GET_APP_DOMAIN_LIST = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "SECURITYPLUS701") {
      return APP_DOMAIN_LIST_SEC_701;
    } else if (SELECTED_BUNDLE == "SECURITYPLUS") {
      return APP_DOMAIN_LIST_SEC;
    }
  } else {
    return APP_DOMAIN_LIST_SEC;
  }
};



export const STRING = {
  share_message:
    "Hey there, I am using this app to prepare for " +
    APP_NAME +
    " certification exam. I think you will find it very useful. Check it out " +
    app_url,
};

/*** LEADING SCREEN TUTORIAL ARRAY ***/
export const GET_TUTORIALS = () => {
  return [
    {
      title: "Welcome to Your CompTIA Security+ Journey!",
      image: IMAGES.slide_1,
      description:
        "Kudos on taking the first step by installing our app! You've embarked on an exciting path towards achieving your CompTIA Security+ certification. This milestone has propelled countless professionals forward in their careers, and it's your turn to unlock new opportunities. Let's get started on this transformative journey together!",
    },
    {
      title: "Gauge Your Exam Preparedness!",
      image: IMAGES.slide_2,
      description:
        "Our Readiness Score feature offers a straightforward method to evaluate how prepared you are for the actual CompTIA Security+ exam. It highlights the areas that require more attention in your study plan, enhancing your chances of acing the test. Let's pinpoint where you can level up and ensure your success!",
    },
    {
      title: "Perfect Your Skills with Practice!",
      image: IMAGES.slide_3,
      description:
        "Dive into mastery by crafting personalized practice tests tailored to your specific needs. Select your desired topics and question count, or opt for our pre-designed practice tests and mock exams. Our custom test engine enhances your preparation by focusing on new questions and areas where you need the most improvement. Practice makes perfect—let's make every study session count!",
    },
    {
      title: "Monitor Your Learning Journey",
      image: IMAGES.slide_4,
      description:
        "Effortlessly track your study progress and review completed tests. Re-take tests as needed to ensure mastery. Stay focused and on track to achieving your certification goals.",
    },
    {
      title: "Study Anywhere, Anytime",
      image: IMAGES.slide_5,
      description:
        "Accessible on both iOS and Android, our app lets you study on your terms—anywhere, anytime. Enjoy seamless synchronization across devices for a flexible learning experience.",
    },
  ];
};

export const GET_QUICK_ASSESSMENT = () => {
  return {
    title: "Assessment Test",
    image: IMAGES.quick_assessment,
    description:
      "This assessment test will help us prepare your baseline readiness score.",
  };
};

/** FLASH CARD MENU */
export const GET_STUDY_QUESTION_MENU = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "SECURITYPLUS701") {
      return GET_STUDY_QUESTION_MENU_SEC_701();
    } else if (SELECTED_BUNDLE == "SECURITYPLUS") {
      return GET_STUDY_QUESTION_MENU_SEC();
    }
  } else {
    return GET_STUDY_QUESTION_MENU_SEC();
  }
};

export const GET_FLASH_CARD_MENU = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "SECURITYPLUS701") {
      return GET_FLASH_CARD_MENU_SEC_701();
    } else if (SELECTED_BUNDLE == "SECURITYPLUS") {
      return GET_FLASH_CARD_MENU_SEC();
    }
  } else {
    return GET_FLASH_CARD_MENU_SEC();
  }
};

/** PLAN DETAILS */
export const PREMIUM_PLAN_DETAILS = [
  "Unlock the full potential of your CompTIA Security+ exam preparation with Learnzapp's premium access. Gain unlimited entry to extensive study materials, personalized practice tests, detailed progress tracking, and expert insights from Darril Gibson and Joe Shelley. Subscribe now to access all features and ensure your success in the SY0-601 and SY0-701 exams."
];

export const FREE_PLAN_DETAILS = [
  "Limited access to a selection of questions and flashcards. Explore the app's features with the free plan before upgrading to premium."
];

/** PLAN PRICING */
export const PLAN_PRICING = [
  {
    off_percentage: "",
    month_price: "$5",
    bill_price: "$5",
    bill_time: "Monthly",
  },
  {
    off_percentage: "10% Off",
    month_price: "$4",
    bill_price: "$24",
    bill_time: "Quarterly",
  },
  {
    off_percentage: "",
    month_price: "$3",
    bill_price: "$36",
    bill_time: "Annually",
  },
];

/** PROFILE MENU */
export const GET_PROFILE_MENU = () => {
  return [
    {
      title: "App Appearance",
      image: IMAGES?.ic_dark_mode,
    },
    {
      title: "Account Setting",
      image: IMAGES?.ic_account,
    },
    {
      title: "Settings",
      image: IMAGES?.ic_subscription,
    },
    {
      title: "Reset App Data",
      image: IMAGES?.ic_reset,
    },
    {
      title: "Share this app",
      image: IMAGES?.ic_share_app,
    },
    {
      title: "Review App",
      image: IMAGES?.ic_review,
    },
    {
      title: "Other Apps",
      image: IMAGES?.ic_other_app,
    },
    {
      title: "Help and Support",
      image: IMAGES?.ic_help,
    },
  ];
};

export const GET_APP_HEADER_LOGO = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "SECURITYPLUS701") {
      return LOGO_SEC_701;
    } else if (SELECTED_BUNDLE == "SECURITYPLUS") {
      return LOGO_SEC;
    }
  } else {
    return LOGO_SEC;
  }
};

export const GET_APP_LANDSACPE_HEADER_LOGO = (SELECTED_BUNDLE) => {
  if (SELECTED_BUNDLE) {
    if (SELECTED_BUNDLE == "SECURITYPLUS701") {
      return LOGO_SEC_701;
    } else if (SELECTED_BUNDLE == "SECURITYPLUS") {
      return LOGO_SEC;
    }
  } else {
    return LOGO_SEC;
  }
};

export const ENABLE_PUSH = false;
export const THIRD_PARTY_CONFIG = {
  STRIPE_PRODUCT_ID: process.env.REACT_APP_STRIPE_PRODUCT_ID,
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
};